import React from "react";
import {
    X,
    ChevronUp,
    ChevronDown,
    RotateCcw,
    Columns2,
    Rows2,
} from "lucide-react";

const btnClass =
    "p-1 rounded hover:bg-gray-700 text-gray-300 hover:text-white disabled:opacity-40 disabled:cursor-not-allowed transition-colors";

export default function DiffViewToolbar({
    versionLabel,
    isInline,
    onToggleInline,
    onPrevChange,
    onNextChange,
    onRevert,
    onClose,
    changeIndex,
    totalChanges,
}) {
    return (
        <div className="flex items-center justify-between px-3 py-1.5 bg-gray-800 text-white text-xs flex-shrink-0 select-none">
            <div className="flex items-center gap-3">
                <span className="font-medium text-gray-200">
                    {versionLabel}
                </span>
                <span className="text-gray-200">
                    vs
                </span>
                <span className="font-medium text-gray-200">
                    Current
                </span>
                {totalChanges > 0 && (
                    <span className="text-gray-400 ml-1">
                        Change {changeIndex + 1} of {totalChanges}
                    </span>
                )}
            </div>
            <div className="flex items-center gap-0.5">
                <button
                    onClick={onPrevChange}
                    className={btnClass}
                    disabled={totalChanges === 0}
                    title="Previous Change"
                >
                    <ChevronUp className="w-3.5 h-3.5" />
                </button>
                <button
                    onClick={onNextChange}
                    className={btnClass}
                    disabled={totalChanges === 0}
                    title="Next Change"
                >
                    <ChevronDown className="w-3.5 h-3.5" />
                </button>
                <div className="w-px h-4 bg-gray-600 mx-1.5" />
                <button
                    onClick={onToggleInline}
                    className={btnClass}
                    title={isInline ? "Side by Side" : "Inline"}
                >
                    {isInline ? (
                        <Columns2 className="w-3.5 h-3.5" />
                    ) : (
                        <Rows2 className="w-3.5 h-3.5" />
                    )}
                </button>
                {onRevert && (
                    <>
                        <div className="w-px h-4 bg-gray-600 mx-1.5" />
                        <button
                            onClick={onRevert}
                            className="flex items-center gap-1 px-2 py-1 rounded text-orange-300 hover:bg-gray-700 hover:text-orange-200 transition-colors"
                            title="Revert file to this version"
                        >
                            <RotateCcw className="w-3 h-3" />
                            <span>Revert</span>
                        </button>
                    </>
                )}
                <div className="w-px h-4 bg-gray-600 mx-1.5" />
                <button
                    onClick={onClose}
                    className={btnClass}
                    title="Close Diff"
                >
                    <X className="w-3.5 h-3.5" />
                </button>
            </div>
        </div>
    );
}
